import { Tag } from 'antd';

export function PosReturnScopeTag({ scope }: { scope?: 'partial' | 'full' }): JSX.Element | null {
  if (!scope) return null;
  return <Tag color={scope === 'partial' ? 'orange' : 'green'}>{scope === 'partial' ? 'Hoàn một phần' : 'Hoàn toàn bộ'}</Tag>;
}
